// Ensure global jQuery reference
$ = jQuery;

$(document).ready(function () {

});
